import type { AddressFormVariant } from "../../config";

export const isAddressFormExtendedWithProvince = (addressFormVariant: AddressFormVariant) =>
  addressFormVariant === "extended_with_province" || addressFormVariant === "extended_with_province_reversed";
